import { Component, OnInit, Input } from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';

// Interfaces
import { ShippingCarrierApiService } from '../../../shared/services/api/shipping-carrier-api.service';
import { SystemSettingApiService } from '../../../shared/services/api/system-setting-api.service';
import { SystemSettingInterface } from '../../../system-setting/interfaces/system-setting.interface';

// Services

@Component({
  selector: 'lum-rfq-shipping-packing-form',
  templateUrl: './rfq-shipping-packing-form.component.html',
  styleUrls: ['./rfq-shipping-packing-form.component.scss'],
})
export class RfqShipPackDetailsComponent implements OnInit {
  @Input()
  form :UntypedFormGroup;

  settings :any = [];
  shippingCarriers :any = [];
  weightUnits :string[] = ['lbs', 'oz'];

  settings$ :Observable<SystemSettingInterface[]>;
  shippingCarriers$ :Observable<any>;

  private onDestroy$ = new Subject();

  constructor(
    private fb :UntypedFormBuilder,
    private settingsApiService :SystemSettingApiService,
    private shippingCarrierApiService :ShippingCarrierApiService,
  ) {}

  ngOnInit() :void {
    this.initDefaults();
    this.getDataFromService();
    this.getSettings().subscribe();
    this.getShippingCarriers().subscribe();
  }

  onAddWeight(key :string, item ?:any) :void {
    const weights = this.form.get(key) as UntypedFormArray;
    const weightFc :any = this.fb.group({
      wv: [item ? item.wv : 0, Validators.required],
      mu: [item ? item.mu : 'lbs', Validators.required],
    });
    weights.push(weightFc);
  }

  onRemoveWeight(key :string, idx :number) :void {
    const weights = this.form.get(key) as UntypedFormArray;
    weights.removeAt(idx);
  }
  private initDefaults() :void {
    this.onAddWeight('productWeights');
    this.onAddWeight('dimensionalWeights');
    this.onAddWeight('shippingWeights');
    this.onAddWeight('boxWeights');
    this.onAddWeight('cartonWeights');
  }

  private getDataFromService() :void {
    this.settings$ = this.settingsApiService.settings$;
    this.shippingCarriers$ = this.shippingCarrierApiService.carriers$;
  }

  private getSettings() :Observable<SystemSettingInterface[]> {
    return this.settings$.pipe(
      tap((settings :SystemSettingInterface[]) => {
        settings.forEach((row :any) => {
          try {
            this.settings[row.key] = JSON.parse(row.value);
          } catch (e) {}
        });
      }),
      takeUntil(this.onDestroy$),
    );
  }

  private getShippingCarriers() :Observable<any> {
    return this.shippingCarriers$.pipe(
      tap((carriers :any) => {
        this.shippingCarriers = carriers?.data || [];
      }),
      takeUntil(this.onDestroy$),
    );
  }

  get productWeightsControl() :UntypedFormArray {
    return this.form.get('productWeights') as UntypedFormArray;
  }

  get shippingWeightsControl() :UntypedFormArray {
    return this.form.get('shippingWeights') as UntypedFormArray;
  }

  get boxWeightsControl() :UntypedFormArray {
    return this.form.get('boxWeights') as UntypedFormArray;
  }

  get cartonWeightsControl() :UntypedFormArray {
    return this.form.get('cartonWeights') as UntypedFormArray;
  }

  get palletWeightsControl() :UntypedFormArray {
    return this.form.get('palletWeights') as UntypedFormArray;
  }
}
